export enum BoxedAppearance {
  NONE = 'No boxed appearance',
  ENCASED_LEFT = 'No left border on first item. Nav bar is encased and left-aligned',
  ENCASED_RIGHT = 'No left border on last item. Nav bar is encased and right-aligned',
  ENCASED_BOTH = 'No left border on first item and right border on last item. Nav bar is encased on both sides',
  NON_ENCASED = 'Normal left and right borders.',
}
